module.exports = __webpack_public_path__ + "static/media/level-up-bg.fd20ba00.png";